import { ReactNode, useState } from "react";
import useDialogHooks from "../../../../../../../../Components/Dialog/dialog-hooks";
import SettingsDialog from "../../../../../../../../Components/Dialog/DialogContents/UserProfile/Settings/settingsDialog";
import { useDrawerHooks } from "../../../../../../../../Components/Drawer/drawer-hooks";
import { IVisitorMenuHooks } from "./menuHeader";
import SearchDrawer from '../../Drawer/SearchDrawer/searchDrawer';
import HeaderMenuDrawer from "../../Drawer/HeaderMenuDrawer/headerMenuDrawer";
import { VisitorPageContents } from "../../../../../visitorPage";

const useHeaderHooks = (props: IVisitorMenuHooks) => {
   const { menu_list, logo, is_user, services, searchHandler, companyId, setContentType, onOpenReserveDialog } = props;
   const tableReservation = services?.reserve;
   const { open, onOpen, onClose } = useDialogHooks();
   const { openDrawer, onCloseDrawer, onOpenDrawer } = useDrawerHooks();
   const [dialogComponent, setDialogComponent] = useState<ReactNode>(<></>);
   const [drawercomponent, setDrawerComponent] = useState<ReactNode | null>(null);

   const onCloseHeaderDrawer = () => {
      setDrawerComponent(null);
      onCloseDrawer()
   };

   const onReserveTableDialog = () => {
      onCloseHeaderDrawer();
      onOpenReserveDialog();
   }

   const onOpenSearchDrawer = () => {
      setDrawerComponent(
         <SearchDrawer
            logo={logo}
            menu_list={menu_list}
            searchHandler={searchHandler}
            onCloseDrawer={onCloseDrawer}
         />
      );
      onOpenDrawer();
   };

   const onOpenMenuDrawer = () => {
      setDrawerComponent(
         <HeaderMenuDrawer
            logo={logo}
            onClose={onCloseHeaderDrawer}
            active={VisitorPageContents.MENU}
            companyId={companyId}
            setContentType={setContentType}
            is_user={is_user}
            tableReservation={tableReservation}
            onReserveTableDialog={onReserveTableDialog}
         />
      );
      onOpenDrawer()
   };

   const onOpenSettingDialog = () => {
      onOpen();
      setDialogComponent(<SettingsDialog onClose={onClose} />)
   };

   return {
      open,
      openDrawer,
      dialogComponent,
      drawercomponent,
      onClose,
      onOpenMenuDrawer,
      onOpenSearchDrawer,
      onOpenSettingDialog,
      onCloseHeaderDrawer,
   };
};

export default useHeaderHooks;